import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/account/view/license.account.matches.query.gql"
import type {
  LicenseAccountMatchesQuery,
  LicenseAccountMatchesQueryVariables,
} from "@/v2-backoffice-client/license/account/view/__types__/license.account.matches.query"

type Options = QueryHookOptions<
  LicenseAccountMatchesQuery,
  LicenseAccountMatchesQueryVariables
>

export function useLicenseAccountMatchesQuery(options?: Options) {
  return useQuery<
    LicenseAccountMatchesQuery,
    LicenseAccountMatchesQueryVariables
  >(query, options)
}
